import React, { useEffect, useState } from "react";
import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { ButtonType } from "@/types/ui-kit/buttons";
import { useRouter } from "next/router";
import { db } from "@/db";
import { useIsAppOnline } from "@/hooks/useIsAppOnline";
import Image from "next/image";

export default function OfflinePageContent() {
  const router = useRouter();
  const isAppOnline = useIsAppOnline();
  const [downloadedPostsCount, setDownloadedPostsCount] = useState<number>(0);

  useEffect(() => {
    db.posts.count().then((count) => {
      setDownloadedPostsCount(count);
    });
  }, []);

  const tryAgain = () => {
    if (isAppOnline) {
      router.push("/");
      return;
    }

    return window.location.reload();
  };

  return (
    <div className="flex min-h-screen">
      <div className="m-auto max-w-[400px] px-8 text-center">
        <Image src="/assets/images/icons/offline.svg" className="mx-auto" width={64} height={64} alt="Offline" />
        <h3 className="mt-6 font-mercury text-xl font-semibold">Jste offline</h3>
        <p className="mt-2 text-base">Prosím zkontrolujte svoje internetové připojení</p>

        <div className="mx-auto mt-[20px] flex w-full max-w-[280px] flex-col gap-[16px]">
          {!!downloadedPostsCount ? (
            <>
              <div className="overflow-hidden rounded-full">
                <BaseButton
                  href="/ulozene#downloads"
                  title="Zobrazit stažený obsah"
                  type={ButtonType.Primary}
                  fullWidth
                />
              </div>
              <div className="overflow-hidden rounded-full">
                <BaseButton onClick={tryAgain} title="Zkusit znovu" type={ButtonType.Transparent} fullWidth />
              </div>
            </>
          ) : (
            <div className="overflow-hidden rounded-full">
              <BaseButton onClick={tryAgain} title="Zkusit znovu" type={ButtonType.Primary} fullWidth />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
